// NOVAPAY-116-RC3-R3 — Telegram WebView vs plain browser entry detection (no initData in URLs).
const DIRECT_BROWSER_CONTINUE_KEY = "store-v2-direct-browser-continue-v1";

export function hasTelegramMiniAppContext(): boolean {
  try {
    const tg = (window as unknown as { Telegram?: { WebApp?: { initData?: string; platform?: string } } })
      .Telegram?.WebApp;
    const initData = tg?.initData?.trim() ?? "";
    if (initData.length > 0) return true;
    const platform = tg?.platform?.trim() ?? "";
    return platform.length > 0 && platform !== "unknown";
  } catch {
    return false;
  }
}

export function readDirectBrowserContinueAllowed(): boolean {
  try {
    return window.sessionStorage.getItem(DIRECT_BROWSER_CONTINUE_KEY) === "1";
  } catch {
    return false;
  }
}

export function persistDirectBrowserContinueAllowed(): void {
  try {
    window.sessionStorage.setItem(DIRECT_BROWSER_CONTINUE_KEY, "1");
  } catch {
    /* ignore */
  }
}

export function clearDirectBrowserContinueAllowed(): void {
  try {
    window.sessionStorage.removeItem(DIRECT_BROWSER_CONTINUE_KEY);
  } catch {
    /* ignore */
  }
}
